import reducer from "./reducers";
import { routes } from "../routes";

export default {
    routes,
    reducer
}